import {createApp} from "vue";

import App from "./App.vue";

// import 'vuestic-ui/dist/vuestic-ui.css' // <-
import {VuesticPlugin} from "vuestic-ui"; // <-

import PrimeVue from "primevue/config";
import "../node_modules/primeflex/primeflex.css";
import "primevue/resources/themes/saga-blue/theme.css"; //theme
import "primevue/resources/primevue.min.css"; //core css
import "primeicons/primeicons.css";

import ToastService from "primevue/toastservice";
import Toast from 'primevue/toast';
import ConfirmationService from 'primevue/confirmationservice';

import VueCookies from "vue3-cookies";
import router from "./router/router";

const app = createApp(App);
app.use(VueCookies, {
    expireTimes: "7d",
    secure: true,
});
app.use(router);
app.use(PrimeVue);
app.use(VuesticPlugin);
app.use(ToastService);
app.use(ConfirmationService)
app.component(Toast)
app.mount("#app");
